import type { ExpandedRowProps } from './types'

import { Table } from 'antd'
import React from 'react'

import { currencyFormatter } from './functions'
import dayjs from 'dayjs'

export const ExpandedRow = (props: ExpandedRowProps): React.JSX.Element => {
  return (
    <Table
      title={() => 'Transactions'}
      dataSource={props.row}
      size='small'
      rowKey='bankRefNumber'
      columns={[
        {
          key: 'date',
          dataIndex: 'date',
          title: 'Date',
          render: (value: string) => dayjs.utc(value).format('MM/DD/YYYY')
        },
        {
          key: 'code',
          dataIndex: 'code',
          title: 'Code'
        },
        {
          key: 'type',
          dataIndex: 'type',
          title: 'Type'
        },
        {
          key: 'amount',
          dataIndex: 'amount',
          title: 'Amount',
          render: value => currencyFormatter(value / 100)
        },
        {
          key: 'bankRefNumber',
          dataIndex: 'bankRefNumber',
          title: 'Bank Ref Number'
        },
        {
          key: 'customerRefNumber',
          dataIndex: 'customerRefNumber',
          title: 'Customer Ref Number'
        },
        {
          key: 'text',
          dataIndex: 'text',
          title: 'Text'
        }
      ]}
    />
  )
}
